import { useState } from "react";

import {
  ProductRegion,
  useClientRegister,
} from "contexts/register/ClientContext";
import { InfoTag } from "../../../InfoTag";

import Input from "../../../Input";

import { RegionTag } from "./RegionTag";
import { MoneyInput } from "components/MoneyInput";
import { EmptyState } from "components/display/EmptyState";

import * as S from "./styles";

function RegionForm() {
  const {
    errors,
    regions,
    productRegions,
    setProductRegions,
    removeProductRegion,
    removeRegion,
    removeError,
  } = useClientRegister();

  const [region, setRegion] = useState<string>("");
  const [regionValue, setRegionValue] = useState<number>(0);
  const [hourValue, setHourValue] = useState<number>(0);
  const [kmValue, setKmValue] = useState<number>(0);

  function handleRegionSubmit() {
    removeError("regions");

    const _region: ProductRegion = {
      name: region,
      regionValue,
      hourValue,
      kmValue,
    };

    setProductRegions((list) => {
      const _list = [...list];
      _list.push(_region);

      return _list;
    });

    setRegion("");
    setRegionValue(0);
    setHourValue(0);
    setKmValue(0);
  }

  function onFormEnter(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    handleRegionSubmit();
  }

  return (
    <S.Wrapper>
      <S.Form>
        <S.FormColumn>
          <h3>Adicionar valores de região</h3>

          <S.RegionContainer>
            <S.ValueForm onSubmit={onFormEnter}>
              <S.RegionInputContainer>
                <Input
                  id="type"
                  name="type"
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setRegion(event.target.value);
                  }}
                  value={region}
                  label="Nome da região"
                  required={true}
                  type="text"
                  inputClassname="region"
                  error={
                    (errors.regions && "Nenhuma região adicionada") ||
                    errors["product.regions"]
                  }
                />
              </S.RegionInputContainer>
              <S.ValuesContainer>
                <header>
                  <h4>Valores separados por</h4>
                </header>

                <S.FormGroup>
                  <MoneyInput
                    id="region_value"
                    name="region_value"
                    label="Região"
                    required
                    onCurrencyChange={(currency) => setRegionValue(currency)}
                    defaultValue={regionValue}
                  />
                  <MoneyInput
                    id="additional_km"
                    name="additional_km"
                    label="KM adicional"
                    required
                    onCurrencyChange={(currency) => setKmValue(currency)}
                    defaultValue={kmValue}
                  />
                  <MoneyInput
                    id="additional_hour"
                    name="additional_hour"
                    label="Hora adicional"
                    required
                    onCurrencyChange={(currency) => setHourValue(currency)}
                    defaultValue={hourValue}
                  />
                </S.FormGroup>
              </S.ValuesContainer>

              <button type="submit" />
            </S.ValueForm>

            <button
              disabled={region === "" || regionValue === 0}
              type="button"
              onClick={() => handleRegionSubmit()}
            >
              Adicionar região
            </button>
          </S.RegionContainer>
        </S.FormColumn>
        <S.FormColumn>
          <S.RegionList>
            <label>Valores das regiões já adicionadas</label>

            {regions.length === 0 && productRegions.length === 0 && (
              <EmptyState title="Nenhum valor por região adicionado no momento" />
            )}

            {regions &&
              regions.map((_region, index) => (
                <InfoTag
                  key={index}
                  text={`${_region[0]} (R$${_region[1]})`}
                  onClose={() => {
                    removeRegion(_region);
                  }}
                />
              ))}

            {productRegions &&
              productRegions.map((_region, index) => (
                <RegionTag
                  key={index}
                  region={_region}
                  onClose={() => {
                    removeProductRegion(_region, index);
                  }}
                />
              ))}
          </S.RegionList>
        </S.FormColumn>
      </S.Form>
    </S.Wrapper>
  );
}

export { RegionForm };
